module.exports = __webpack_public_path__ + "static/liveitmodheader-c5093aebac2a19ced439a3b6e7ffe098.png";